import Configurator from "../../config/Configurator";
import axios from "axios";

export const fetchApi = async (endpoint, desiredKey, _method = "post") => {
  try {
    let config = {
      method: _method,
      url: (await Configurator()).API_URL + "/v2/io/" + endpoint,
      headers: {
        ...axios.defaults.headers.common,
        ...{
          Session: localStorage.getItem("apiKey"),
          "User-Id": localStorage.getItem("userID"),
        },
      },
    };
    const response = await axios.request(config);
    return response.data?.data?.[desiredKey];
  } catch (error) {
    return {};
  }
};
